import React from 'react';
import { Chat, block } from '@iqueue/iq-ui';
import MessageRows from './MessageList';
import { useChatComposer } from './ChatInput';
import { handleRenderedContentClick } from '../../lib/formatters';

/**
 * The chat block. Chat.Root buckets its parts BY IDENTITY, so Chat.Log and
 * Chat.Composer must be its literal direct children — a part hidden inside a
 * wrapper component lands in the flow region and neither fills nor docks.
 * Declared with block('fill') so the Container plate reads the block axis
 * through this composite (recipe: «Chat screen», closing note).
 */
function ChatView({
  messages, runs, runKeys, approvals, humanRequests, hasMore, loading, members, currentRoom, me,
  replyTo, onReply, onCancelReply, onLoadOlder, onSendMessage,
  onCancelRun, onRetrySend, onDropMessage, onDecideApproval, onAnswerRequest,
}) {
  const { composer, suggestions, onFiles } = useChatComposer({
    onSend: onSendMessage, members, currentRoom, replyTo, onCancelReply,
  });

  return (
    <Chat.Root>
      <Chat.Log
        aria-label="Сообщения"
        onLoadOlder={hasMore && !loading ? onLoadOlder : undefined}
        loadingOlder={!!loading}
        onFiles={onFiles}
        onClick={handleRenderedContentClick}
      >
        <MessageRows
          messages={messages}
          runs={runs}
          runKeys={runKeys}
          approvals={approvals}
          humanRequests={humanRequests}
          hasMore={hasMore}
          me={me}
          onReply={onReply}
          onCancelRun={onCancelRun}
          onRetrySend={onRetrySend}
          onDropMessage={onDropMessage}
          onDecideApproval={onDecideApproval}
          onAnswerRequest={onAnswerRequest}
        />
      </Chat.Log>
      {suggestions}
      {composer}
    </Chat.Root>
  );
}

export default block('fill', React.memo(ChatView));
